"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matrixToString = exports.matrixStringToObj = exports.splitToLine = exports.ConvertCase = exports.NormalizeTemplateText = exports.NormalizeText = exports.SplitEqual = exports.GetWords = void 0;

var _string = require("lodash/string");

function toCapitalize(str) {
  return str.toLowerCase().replace(/./, function (x) {
    return x.toUpperCase();
  }).replace(/(^| |\.|,|-)(.)/g, function (y) {
    return y.toUpperCase();
  });
}

var GetWords = function GetWords(str) {
  return str.split(/ /g);
};

exports.GetWords = GetWords;

var SplitEqual = function SplitEqual(str, length) {
  var result = [];
  var currentFormat = null;
  var currentLine = '';
  var currentLineLengthWithoutFormatting = 0; // 1. Split on space / &nbsp;

  var words = GetWords(str); // console.log(words.length)
  // 2. Re-assemble lines while keeping track of current formats

  words.forEach(function (word) {
    // Keep track of current format
    var wordWithFormatting;
    var wordLength; // Apply current format to each word separatly

    wordLength = word.length;
    wordWithFormatting = (currentFormat || '') + word;

    if (currentFormat) {
      if (word.indexOf(']') !== -1) {
        wordLength--;
        currentFormat = null;
      } else {
        wordWithFormatting += ']';
      }
    } // Assemble line


    if (currentLineLengthWithoutFormatting + wordLength <= length) {
      // Word still fits on current line
      if (currentLineLengthWithoutFormatting > 0) {
        currentLine += ' ';
        currentLineLengthWithoutFormatting++;
      }
    } else {
      // Need to start new line
      if (currentLine.length > 0) {
        result.push(currentLine);
      }

      currentLine = '';
      currentLineLengthWithoutFormatting = 0;
    }

    currentLine += wordWithFormatting;
    currentLineLengthWithoutFormatting += wordLength;
  });

  if (currentLineLengthWithoutFormatting > 0) {
    result.push(currentLine);
  }

  return result;
};

exports.SplitEqual = SplitEqual;

var NormalizeText = function NormalizeText(str) {
  str = str.replace("$", "$$$$").replace(/\r|\n|(\n\r)/ig, '<br>');
  str = JSON.stringify(str);
  return str.substring(1, str.length - 1);
};

exports.NormalizeText = NormalizeText;

var NormalizeTemplateText = function NormalizeTemplateText(str) {
  str = str.replace("$", "$$$$").replace(/(\n\r)|\r|\n|(<br>)/ig, '\n\r');
  str = JSON.stringify(str);
  return str.substring(1, str.length - 1);
};

exports.NormalizeTemplateText = NormalizeTemplateText;

var ConvertCase = function ConvertCase(str, caseName) {
  switch (caseName) {
    case 'uppercase':
      str = (0, _string.toUpper)(str);
      break;

    case 'lowercase':
      str = (0, _string.toLower)(str);
      break;

    case 'capitalize':
      str = toCapitalize(str);
      break;

    default:
      break;
  }

  return str;
};

exports.ConvertCase = ConvertCase;

var splitToLine = function splitToLine(str, maxLine, maxCharInline) {
  var output = [];
  var curr = maxCharInline;
  var prev = 0;

  while (str[curr]) {
    if (str[curr + 1] === ' ') {
      output.push(str.substring(prev, ++curr).trim());
      prev = curr;
      curr += maxCharInline;
    } else {
      curr++;
    }
  }

  output.push(str.substr(prev).trim());
  var lines = output.slice(0, maxLine);
  var last = lines[lines.length - 1];

  if (last.length > maxCharInline) {
    if (last.length >= maxCharInline - 3) {
      var lastWordIndex = str.lastIndexOf(' ');
      last = "".concat(last.substring(0, lastWordIndex), "...");
    } else {
      last += '...';
    }

    lines[lines.length - 1] = last;
  }

  return lines;
};

exports.splitToLine = splitToLine;

var matrixStringToObj = function matrixStringToObj(str) {
  var arr = str.replace(/^.*\((.*)\)$/g, '$1').split(',').map(Number);
  return {
    a: arr[0],
    b: arr[1],
    c: arr[2],
    d: arr[3],
    e: arr[4],
    f: arr[5]
  };
};

exports.matrixStringToObj = matrixStringToObj;

var matrixToString = function matrixToString(obj) {
  var a = obj.a,
      b = obj.b,
      c = obj.c,
      d = obj.d,
      e = obj.e,
      f = obj.f;
  return "matrix(".concat(a, ",").concat(b, ",").concat(c, ",").concat(d, ",").concat(e, ",").concat(f, ")");
};

exports.matrixToString = matrixToString;